/* eslint-disable no-unused-vars */
import { isEmptyObj } from "../../utils/helper";
import { post as postAxios, get as getAxios } from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const get = (url, { accessToken, data, params }) =>
  getAxios(url, { accessToken, data, endPoint, params });

const PAGE_SIZE = 10;

export default class Member {
  static search(data, params) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/members/search", {
      accessToken: accessTokenFromLocal,
      data: isEmptyObj(data) ? null : data,
      params: {
        size: PAGE_SIZE,
        page: params.page,
      },
    });

    Member.search.cancel = request.cancel;
    return request;
  }

  static adminSearch(data, params) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/members/adminSearch?page=${params.page}&size=${params.pageSize}`,
      {
        accessToken: accessTokenFromLocal,
        data: isEmptyObj(data) ? null : { ...data },
        params: {
          size: PAGE_SIZE,
          page: params.page,
        },
      }
    );

    Member.adminSearch.cancel = request.cancel;
    return request;
  }
}
